import abi from "./contract/GlobalPool.json";
import abi1 from "./contract/a/GlobalPool.json";
import { useState, useEffect } from "react";
import { ethers } from "ethers";
import Buy from "./component/buy";
import Buy1 from "./component/buy1";
import Memos from "./component/memos";
import "./copy.png";
import Buy3 from "./component/buy3";



function App() {
  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  
     const [state1, setState1] = useState({
    provider: null,
    signer: null,
    contract1: null,
  });


  const [account, setAccount] = useState("None");
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[wlevel,setLevelw]=useState("None");
  const[level1,setLevel1]=useState("None");
  const[wlevel1,setLevelw1]=useState("None");
  const[plevel,setLevelp]=useState("None");
  const[pack,setpackage]=useState("None");
  const[pack3,setpackage3]=useState("None");
  const[pack1,setpackage1]=useState("None");
  const[refer,setrefer]=useState("None");
  const[refer4,setrefer4]=useState("None");
  const[refer3,setrefer3]=useState("None");
  const[refer1,setrefer1]=useState("None");
  const[refer2,setrefer2]=useState("None");
const [tasks,setTasks] = useState([]);
const [tasks1,setTasks1] = useState([]);
const [tasks2,setTasks2] = useState([]);
const [tt,settt]=useState("None");
const [tt4,settt4]=useState("None");
const[dd,setDD]=useState("None");
const[dd1,setDD1]=useState("None");
const[dd2,setDD2]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[upd,setupd]=useState("None");
const [tt1,settt1]=useState("None");
const [roi,seroi]=useState("None");
const [roi1,seroi1]=useState("None");
const [roi2,seroi2]=useState("None");
const [a1,sea1]=useState("None");
const [a2,sea2]=useState("None");
const [a3,sea3]=useState("None");
const [tt2,settt2]=useState("None");
const [tt3,settt3]=useState("None");
const[b1,setb1]=useState("None");
const[b2,setb2]=useState("None");
const[b3,setb3]=useState("None");
const[b4,setb4]=useState("None");
const[b5,setb5]=useState("None");
const[b6,setb6]=useState("None");
const[b7,setb7]=useState("None");
const[b8,setb8]=useState("None");
const[b9,setb9]=useState("None");
const[b10,setb10]=useState("None");
const[b11,setb11]=useState("None");
const[b12,setb12]=useState("None");
const[b13,setb13]=useState("None");
const[b14,setb14]=useState("None");
const[b15,setb15]=useState("None");
const[b16,setb16]=useState("None");
const[b17,setb17]=useState("None");
const[reward,setreward]=useState("None");
const[reward1,setreward1]=useState("None");
const[reward2,setreward2]=useState("None");
const[reward3,setreward3]=useState("None");
const[reward4,setreward4]=useState("None");
const[reward5,setreward5]=useState("None");
const[reward6,setreward6]=useState("None");
const[reward7,setreward7]=useState("None");
const[reward8,setreward8]=useState("None");
const[reward9,setreward9]=useState("None");
const[reward10,setreward10]=useState("None");

const[x1,setx1]=useState("None");
const[x2,setx2]=useState("None");
const[x3,setx3]=useState("None");
const[x4,setx4]=useState("None");
const[x5,setx5]=useState("None");

const[x11,setx11]=useState("None");
const[x12,setx12]=useState("None");
const[x13,setx13]=useState("None");
const[x14,setx14]=useState("None");
const[x15,setx15]=useState("None");
const[x16,setx16]=useState("None");
const[x17,setx17]=useState("None");
const[x18,setx18]=useState("None");


const[pp1,setpp1]=useState("None");
const[pp2,setpp2]=useState("None");
const[pp3,setpp3]=useState("None");

  useEffect(() => {
    
    const connectWallet = async () => {
      
      const contractAddress = "0x8e1858e5fabae5b2f084dd892aab33bdf07ad835";
      const contractABI = abi.abi;




      const searchParams = new URLSearchParams(window.location.search);
    const myParam = searchParams.get('ref');
    console.log(myParam);
    document.querySelector("#name").value=myParam;
     document.querySelector("#refer").value  = myParam;

  
  try {
    const { ethereum } = window;
  //  document.querySelector("#test").value = "0";
    if (ethereum) {
      const account = await ethereum.request({
        method: "eth_requestAccounts",
       
      });
     
      window.ethereum.on("chainChanged", () => {
        window.location.reload();
      });

      window.ethereum.on("accountsChanged", () => {
        
        window.location.reload();
      });
          const provider = new ethers.providers.Web3Provider(ethereum);
        
          try {
            const selectedNetwork = await provider.getNetwork();
          
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
        
        
        
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );

          setAccount(account);
          setState({ provider, signer, contract });

          document.querySelector("#us").value  = account[0];
      let alltasks = await contract.getMemos(account[0]);
      setTasks(alltasks);



      var i = 0;
      
     const pack = Number(alltasks[3]) ;

setpackage(pack);


      const refer = (alltasks[1]);
      setrefer(refer);
       const pp3 = (alltasks[13]);
      setpp3(pp3);
      
      const refer2 = (alltasks[23]);
     setrefer2(refer2);
	 const x4 = Number(alltasks[22])/1000000000000000000;
     setx4(x4);
      const b =Number(alltasks[2]);
     

     document.querySelector("#hid").value  = (alltasks[1]);
     document.querySelector("#direct").value  = (alltasks[5]);
     document.querySelector("#level").value  = (alltasks[21]);
     document.querySelector("#wid").value  = (alltasks[30])/1000000000000000000;
     const direct =Number(alltasks[2]);
     setDirect(direct);
     const level = Number(alltasks[4]);
     setLevel(level);


     const plevel = Number(alltasks[21])/1000000000000000000;
     setLevelp(plevel);
     
    

document.querySelector("#pp").value  = Number(alltasks[3]);

document.querySelector("#pp4").value  = alltasks[13];



     setB(b);

     

     const dd = Number(alltasks[9]);
          
     setDD(dd);

     const reward1 = Number(alltasks[11])/1000000000000000000;
          
     setreward1(reward1);

     const reward10 = alltasks[13];
          
     setreward10(reward10);
     
     const reward2 = Number(alltasks[17])/1000000000000000000;
          
     setreward2(reward2);
     const reward3 = Number(alltasks[18])/1000000000000000000;
          
     setreward3(reward3);
	   
	 	
								
	
      const reward4 =  Number(alltasks[23])/1000000000000000000;
      setreward4(reward4);
      const reward5 =  Number(alltasks[27]);
      setreward5(reward5);




      const reward6 =  Number(alltasks[28]);
      setreward6(reward6);

      const reward7 =  Number(alltasks[29]);
      setreward7(reward7);


     const x1 = Number(alltasks[17])/1000000000000000000;
     setx1(x1);
     const x2 = Number(alltasks[18])/1000000000000000000;
     setx2(x2);
     const x3 = Number(alltasks[19])/1000000000000000000;
     setx3(x3);


     const x11 = Number(alltasks[23]);
     setx11(x11); 
     const x12 = Number(alltasks[27]);
     setx12(x12);
     const x13 = Number(alltasks[31]);
     setx13(x13);

     const x14 = Number(alltasks[11])/1000000000000000000 ;
     setx14(x14);


     const x15 = Number(alltasks[35])/1000000000000000000 ;
     setx15(x15);
    
      const x16 = Number(alltasks[37])/1000000000000000000 ;
     setx16(x16);
    

      const x17 = Number(alltasks[29])/1000000000000000000 ;
     setx17(x17);
    
      const x18 = Number(alltasks[36])/1000000000000000000 ;
     setx18(x18);
    
    
     


     const dd2 = Number(alltasks[26]);
          
     setDD2(dd2);

     const dd1 =  Date.now() / 1000;
     setDD1(dd1);


     const tt1 = Math.trunc((dd1 - dd) / (3660 * 24 )) ;
   //  const tt1 =  (dd1.getTime() - dd.getTime())/ (1000 * 60 * 60 * 24);
     
     settt1(tt1);

       const b17 = Number(alltasks[15])/1000000000000000000 ;
       setb17(b17);

       const b1 = Number(alltasks[5]) ;
       setb1(b1);
       const b2 = Number(alltasks[6]) ;
       setb2(b2);
       const b3 = Number(alltasks[7]) ;
       setb3(b3);
       const b4 = Number(alltasks[8]) ;
       setb4(b4);
       const b5 = Number(alltasks[9]) ;
       setb5(b5);
       const b6 = Number(alltasks[10]) ;
       setb6(b6);
       const b7 = Number(alltasks[34]) ;
       setb7(b7);

       const b8 = Number(alltasks[31]) ;
       setb8(b8);
       const b9 = Number(alltasks[32]) ;
       setb9(b9);
       const b10 = Number(alltasks[33]) ;
       setb10(b10);
     
	   const wlevel = Number(alltasks[25])/1000000000000000000 ;
          
 setLevelw(wlevel);
 const wlevel1 = Number(alltasks[15])/1000000000000000000;
          
 setLevelw1(wlevel1);
 const level1 = Number(alltasks[21]);
          
 setLevel1(level1);
 

    // document.querySelector("#wi1").value = roi2;
     
    // const a1 = Number(alltasks1[0])-1;
          
    // sea1(a1);
 /*    const a3 = Number(alltasks2[2])/1000000000000000000;
          
     sea3(a3);

     document.querySelector("#pp5").value = a3;
 const a1 = Number(alltasks1[3])/1000000000000000000;
      sea1(a1);
     

     const a2 = Number(alltasks1[2])/1000000000000000000;
    sea2(a2);   */
    const pp1 = Number(alltasks[3]) *2 ;

setpp1(pp1);

const pp2 = pp1 - (Number(alltasks[16])/1000000000000000000 ) ;

setpp2(pp2);
     var rr = 0;
    // const tt4 =  Number(alltasks[15])/1000000000000000000;
    // settt4(tt4);
     
const pack1 = Number(alltasks[30])/1000000000000000000;
setpackage1(pack1);
     const tt =  Number(alltasks[16])/1000000000000000000;
     settt(tt);
     const tt3 = Number(alltasks[10])/1000000000000000000;
     settt3(tt3);
     document.querySelector("#bal").value = tt3;
     const referlink = 'https://globalBVT.world/?ref='+ account;
     setreflink(referlink);
     document.querySelector("#link").value =referlink;


     const upd = b1+b2+b3+b4+b5+b6+b7+b8+b9+b10+b11+b12+b13+b14+b15;
          
     setupd(upd);


console.log(pack);

const tt2 = 1440 - Math.trunc((dd1 - dd2)/60) ;
       
       settt2(tt2);

      if(tt2<0)
      {
        const tt2 = 0;
       
       settt2(tt2);
        const x5 = "Today's Trade Pending" ;
       setx5(x5);
      }
      else
      {
         const x5 = "Trade Already Claimed" ;
       setx5(x5);
      }

       document.querySelector("#tt2").value = tt2;
     


 
        } else {
          alert("Please install metamask");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
   
    
    connectWallet();
    
    function myFunction() {
      
      var copyText = "hello";
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices
      
    
      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.valueOf);
    }

  }, []);

 
  // console.log(state);
  return (
  <div>
   <input type="hidden" id ="pp4"></input>
   <input type="hidden" id ="pp5"></input>
    <input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>
    <input type="hidden" id ="tt2"></input>
    <input type="hidden" id ="wi1"></input>
    <input type="hidden" id ="roi"></input>
    <input type="hidden" id ="bal"></input>
    <input type="hidden" id ="direct"></input>
    <input type="hidden" id ="level"></input>
    <input type="hidden" id ="wid"></input>
    <div class="r-container" style={{paddingBottom:"6em",marginTop:"-5rem"}} >
            <div class="d-flex flex-column gap-5">

               <div
                class="d-flex flex-column gap-2 align-items-center justify-content-center mx-auto text-center scrollanimation animated fadeInDown adr-7"
              >
                <h6 class="text-accent">Why Choose Bootcamp?</h6>
                <h3>Empowering Your Future with GLOBALBVT PRO</h3>
              </div>
              
              <div class="row row-cols-xl-4 row-cols-1">
                <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4 >Refered By</h4>
                      <p>
                       <input style={{
    width: "80%",
    maxWidth: "200px",
    margin: "2px auto",
    textAlign: "center",
    padding: "10px",
    borderRadius: "6px",
    border: "none",
    outline: "none"
  }}  type="text" id ="refer" width={"200px"} ></input>
                      </p>
                    </div>
                  </div>
                </div>
                  <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4 >Deposit</h4>
                      <p>
                       <input type="text" id ="amt"  style={{
    width: "80%",
    maxWidth: "200px",
    margin: "2px auto",
    textAlign: "center",
    padding: "10px",
    borderRadius: "6px",
    border: "none",
    outline: "none",
  

  }}  ></input>
                      </p>
                      
						<Buy state={state}  />
                    </div>
                  </div>
                </div>
                  <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4 >Withdraw </h4>
                      <p>
                        <input  id ="test"  type="text"   style={{
    width: "80%",
    maxWidth: "200px",
    margin: "2px auto",
    textAlign: "center",
    padding: "10px",
    borderRadius: "6px",
    border: "none",
    outline: "none"
  }}  ></input>
                      </p>
                         
						<Buy3 state={state}  />
                    </div>
                  </div>
                </div>
                  <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4 >Trade </h4>
                      <p>
                       
                    <Buy1 state={state}/>
                      </p>
                    </div>
                  </div>
                </div>
                  <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4 >Trade </h4>
                      <p style={{fontSize:"1.5rem"}}>
                        Next Trade In : {tt2} Minutes
                      </p>
                      <p style={{fontSize:"1.3rem"}}>{x5}</p>
                    </div>
                  </div>
                </div>

                  <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Total Deposit </h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {pack} BVT PRO
                      </p>
                      
                    </div>
                  </div>
                </div>
                <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  > My Assets</h4>
                      <p style={{fontSize:"1.7rem"}}>
                         {tt+pack} BVT PRO
                         {a1}
                         {a2}
                      </p>
                      
                    </div>
                  </div>
                </div>
                <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Total Withdraw </h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {b17} BVT PRO
                      </p>
                      
                    </div>
                  </div>
                </div>
                <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Pending Withdraw </h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {tt-b17} BVT PRO
                      </p>
                      
                    </div>
                  </div>
                </div>
                  
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Direct Team </h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {direct}
                      </p>
                      
                    </div>
                  </div>
                </div>
                <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >BVT PRO PRICE (sell) </h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {a1 }
                      </p>
                      
                    </div>
                  </div>
                </div>
                <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >BVT PRO PRICE (buy) </h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {a2}
                      </p>
                      
                    </div>
                  </div>
                </div>
                <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >BVT PRO PURCHASED </h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {a3 }
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Level Team </h4>
                      <p style={{fontSize:"1.7rem"}}>
                       {level}  
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  > Team Business</h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {level1} 
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Total Team </h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {level + direct}
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Revenue Share  </h4>
                      <p style={{fontSize:"1.7rem"}}>
                         {x1} BVT PRO
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  > Direct Bonus</h4>
                      <p style={{fontSize:"1.7rem"}}>
                       {x2} BVT PRO  
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Level Bonus </h4>
                      <p style={{fontSize:"1.7rem"}}>
                          {x3} BVT PRO
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  > Monthly Direct Business</h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {x11} BVT PRO
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  > Monthly Level Business</h4>
                      <p style={{fontSize:"1.7rem"}}>
                         {x12} BVT PRO
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Silever Royalty </h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {x14} BVT PRO
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Gold Royalty </h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {x15} BVT PRO
                      </p>
                      
                    </div>
                  </div>
                </div>
                    <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Diamond Royalty </h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {x16} BVT PRO
                      </p>
                      
                    </div>
                  </div>
                </div>
                    <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Pearl Royalty </h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {x17} BVT PRO
                      </p>
                      
                    </div>
                  </div>
                </div>
                    <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Platinum Royalty </h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {x18} BVT PRO
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >TOTAL WITHDRAWL </h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {wlevel1}  BVT PRO
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  > MAX PROFIT </h4>
                      <p style={{fontSize:"1.7rem"}}>
                         {pp1}  BVT PRO
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  > PENDING PROFIT</h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {pp2}  BVT PRO 
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  > Level 1 Business</h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {b1}  BVT PRO 
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  > Level 2 Business </h4>
                      <p style={{fontSize:"1.7rem"}}>
                         {b2}  BVT PRO
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  > Level 3 Business</h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {b3}  BVT PRO
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Level 4 Business </h4>
                      <p style={{fontSize:"1.7rem"}}>
                         {b4}  BVT PRO
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Level 5 Business </h4>
                      <p style={{fontSize:"1.7rem"}}>
                         {b5}  BVT PRO
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Level 6 Business </h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {b6}  BVT PRO 
                      </p>
                      
                    </div>
                  </div>
                </div>

                <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Level 7 Business </h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {b7}  BVT PRO 
                      </p>
                      
                    </div>
                  </div>
                </div>

                <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Level 8 Business </h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {b8}  BVT PRO 
                      </p>
                      
                    </div>
                  </div>
                </div>

                <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Level 9 Business </h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {b9}  BVT PRO 
                      </p>
                      
                    </div>
                  </div>
                </div>


                <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Level 10 Business </h4>
                      <p style={{fontSize:"1.7rem"}}>
                        {b10}  BVT PRO 
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >Referlink </h4>
                      <p style={{fontSize:"1.7rem"}}>
                                            {referlink} <a href="#">
                    <button><img src ="copy.png" width={"15px"} onClick={() => {
                    navigator.clipboard.writeText(referlink);}} /></button> </a>
                      </p>
                      
                    </div>
                  </div>
                </div>
                 <div class="col mb-3">
                  <div class="card-accent">
                    <div class="bg"></div>
                    <div class="blob"></div>
                    <div class="card-content">
                      <h4  >My Refer  </h4>
                      <p style={{fontSize:"1.7rem"}}>
                         {refer}
                      </p>
                      
                    </div>
                  </div>
                </div>
                

                  

                </div>
                </div>
                </div>

   
    
              <br></br>

   </div>

  );
}

export default App;